import React from 'react';
import {
    Heading,
    FormButtonContainer,
    FormContainer,
    SubHeading,
    SmallText,
    SignUpLink,
    HoverLink,
    SignUpGymContainer,
    SignUpTermsAndConditionsWrapper,
    ClarificationWrapper,
    ClarificationMessage,
} from '../style';
import { AuthenticationWrapper } from '../AuthenticationWrapper';
import { SemiTransparentButton, Row } from '../../../Layouts';

import { Icon } from '../../../Components/Icons/Icons';
import FacebookAuth from '../FacebookAuth';

import { Link } from 'react-router-dom';
import { externalLinks, paths } from '../../../../Constants/paths';

export const SignUpEntry = () => (
    <AuthenticationWrapper>
        <FormContainer>
            <Heading marginBottom={'12px'}>Sign up</Heading>
            <SubHeading marginBottom={'24px'}>Create an account to join the fun</SubHeading>
            <FormButtonContainer>
                <FacebookAuth />
            </FormButtonContainer>

            <ClarificationWrapper>
                <Icon.Box opacity={0.75} size={'12x12'}>
                    <Icon.Lock />
                </Icon.Box>
                <ClarificationMessage>We will never post to Facebook without your permission</ClarificationMessage>
            </ClarificationWrapper>

            <FormButtonContainer>
                <Link to={paths.SIGN_UP_EMAIL}>
                    <SemiTransparentButton>Sign up with email</SemiTransparentButton>
                </Link>
            </FormButtonContainer>

            <SignUpGymContainer>
                <SignUpLink to={paths.SIGN_UP_GYM}>Sign up as a Gym</SignUpLink>
            </SignUpGymContainer>

            <SignUpTermsAndConditionsWrapper>
                <Row>
                    <SmallText marginRight={'4px'}>By signing up to Tona you agree to our</SmallText>
                    <HoverLink to={{ pathname: externalLinks.TERMS_AND_CONDITIONS }} target={'_blank'}>
                        Terms of Service
                    </HoverLink>
                </Row>
                <Row marginTop={'8px'}>
                    <SmallText marginRight={'4px'}>View our</SmallText>
                    <HoverLink to={{ pathname: externalLinks.PRIVACY_POLICY }} target={'_blank'}>
                        privacy policy.
                    </HoverLink>
                </Row>
            </SignUpTermsAndConditionsWrapper>

            <Row>
                <SubHeading marginRight={'8px'}>Already have an account?</SubHeading>
                <SignUpLink to={paths.ENTRY_PAGE}>Sign in</SignUpLink>
            </Row>
        </FormContainer>
    </AuthenticationWrapper>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/SignUp/SignUpEntry.js